import { render } from "./FixedLoader.vue?vue&type=template&id=60f118ab&scoped=true"
import script from "./FixedLoader.vue?vue&type=script&lang=js"
export * from "./FixedLoader.vue?vue&type=script&lang=js"

import "./FixedLoader.vue?vue&type=style&index=0&id=60f118ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f118ab"],['__file',"src/components/global/FixedLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60f118ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60f118ab', __exports__)) {
    api.reload('60f118ab', __exports__)
  }
  
  module.hot.accept("./FixedLoader.vue?vue&type=template&id=60f118ab&scoped=true", () => {
    api.rerender('60f118ab', render)
  })

}


export default __exports__